// copied from apps/crm; consolidate into a shared package in S5 slice 4
// Runtime switches. Mocks from day 1: with no Supabase config, or with
// VITE_AIW_MOCK=1, the portal runs against the in-browser mock of services/api.
// In a Container App the values arrive at RUNTIME through /config.js (nginx renders
// window.__AIW__ from env); the VITE_ values are the dev fallback.
declare global { interface Window { __AIW__?: { supabaseUrl?: string; supabaseAnonKey?: string; apiBase?: string } } }
const rt = (typeof window !== "undefined" && window.__AIW__) || {};
const supabaseUrl = rt.supabaseUrl || (import.meta.env.VITE_SUPABASE_URL as string | undefined) || "";
export const env = {
  supabaseUrl,
  supabaseAnonKey: rt.supabaseAnonKey || (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) || "",
  apiBase: rt.apiBase ?? ((import.meta.env.VITE_AIW_API_BASE as string | undefined) ?? ""),
  platformBase: (import.meta.env.VITE_PLATFORM_BASE as string | undefined) ?? "https://app.artemisio.com.au",
  mock: import.meta.env.VITE_AIW_MOCK === "1" || !supabaseUrl,
};
